import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect, ErrorMessage} from 'formik';
import _get from 'lodash/get';
import classnames from 'classnames';

class CheckBoxGroup extends Component {
  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
    this.handleBlur = this.handleBlur.bind(this);
  }

  handleChange(e) {
    const target = e.currentTarget;
    const {
      id,
      formik: {setFieldValue},
    } = this.props;
    let values = [..._get(this.props.formik.values, id)] || [];

    if (target.checked) {
      values.push(target.id);
    } else {
      values.splice(values.indexOf(target.id), 1);
    }

    setFieldValue(id, values);
  }

  handleBlur() {
    const {
      id,
      formik: {setFieldTouched},
    } = this.props;
    setFieldTouched(id, true);
  }

  render() {
    const {
      id,
      columnClasses,
      formik: {touched, errors, values},
    } = this.props;
    const value = _get(values, id);
    const children = React.Children.toArray(this.props.children);
    const columnsPerRow = (columnClasses && columnClasses.length) || 1;
    const isInvalid = _get(touched, id) && _get(errors, id);
    let groupedChildren = [];
    let grouped = [];
    let remainder;
    for (let i = 0; i < children.length; i++) {
      remainder = i % columnsPerRow;

      if (remainder === 0) {
        grouped = [];
      }

      value &&
        grouped.push(
          <div
            key={grouped.length}
            className={columnClasses && columnClasses[remainder]}
          >
            {React.cloneElement(children[i], {
              field: {
                value: value.includes(children[i].props.id),
                onChange: this.handleChange,
                onBlur: this.handleBlur,
              },
            })}
          </div>
        );

      if (remainder === columnsPerRow - 1 || i === children.length - 1) {
        groupedChildren.push(
          <div key={groupedChildren.length} className={columnClasses && 'row'}>
            {grouped}
          </div>
        );
      }
    }

    return (
      <>
        {groupedChildren}
        {isInvalid && (
          <div
            className={classnames({
              'invalid-feedback': true,
              'd-block': isInvalid,
            })}
          >
            <ErrorMessage name={id} />
          </div>
        )}
      </>
    );
  }
}

CheckBoxGroup.propTypes = {
  id: PropTypes.string.isRequired,
  columnClasses: PropTypes.array,
};

export default connect(CheckBoxGroup);
